import { NgModule } from '@angular/core'
import { AsyncPipe, CommonModule, DatePipe } from '@angular/common'
import { GbLoadingSpinnerComponent } from './gb-loading-spinner/gb-loading-spinner.component'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatDialogModule } from '@angular/material/dialog'
import { GbCurrencyPipe } from './gb-currency-pipe/gb-currency.pipe'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { GbCurrencyDisplayPipe } from './gb-currency-display-pipe/gb-currency-display.pipe'
import { TranslateModule } from '@ngx-translate/core'
import { GbDatePipe } from './gb-date-pipe/gb-date.pipe'
import { GbOrdinalDatePipe } from './gb-ordinal-date-pipe/gb-ordinal-date.pipe'
import { GbCampaignUrlDisplayPipe } from './gb-campaign-url-display-pipe/gb-campaign-url-display.pipe'

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, MatDialogModule, MatAutocompleteModule, TranslateModule],
  declarations: [
    GbLoadingSpinnerComponent,
    GbCurrencyPipe,
    GbCurrencyDisplayPipe,
    GbDatePipe,
    GbOrdinalDatePipe,
    GbCampaignUrlDisplayPipe,
  ],
  exports: [GbCurrencyPipe, GbCurrencyDisplayPipe, GbDatePipe, GbOrdinalDatePipe, GbCampaignUrlDisplayPipe],
  providers: [AsyncPipe, DatePipe],
})
export class GbDashboardSharedUtilsModule {}
